import { Text } from '@chakra-ui/react';

import { selectCourseSettings } from '../api/selectors';
import { useUrlParams } from '../hooks';
import { useAppSelector } from '../store/hooks';

export const DeliveringZeroesMessage: React.FC = () => {
	const { courseId } = useUrlParams();
	const courseSettings = useAppSelector((state) => selectCourseSettings(state, courseId));

	if (!courseSettings?.deliverZerosToLmsAfterGracePeriodEnds) return null;

	return (
		<Text>
			Note that a zero (0) score is delivered to your LMS gradebook for those students who do not
			attempt chapter questions by the due date and after any grace period.
		</Text>
	);
};
